import React from 'react';
import './Promocode.less';
import {PromocodeIcon} from '../promocode-icon/PromocodeIcon';
import {PromocodeText} from '../promocode-text/PromocodeText';

export const Promocode = ({code}) => {
	return (
		<div className="promocode">
      <span className="promocode__icon">
        <PromocodeIcon/>
      </span>
			<span className="promocode__text">
        <PromocodeText text={code}/>
      </span>
		</div>
	);
};
